import React, { useEffect, useRef } from 'react';
import styles from '../EditDiv/EditDiv.module.css';
import buttonStyles from '../YesNoButtonsCSS/YesNoButtons.module.css';
import BlueLogo from '../../assets/BlueLogo.png';
import { Grid, TextField, CircularProgress } from '@mui/material';
import { Form, FormikProvider } from 'formik';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import textfieldStyle from '../../GlobalStyles/styles';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from '../../redux/store';
import { submitTownhallTopic } from '../../redux/slices/townhall';

export default function TownhallForm({ onSubmit, onClose }) {
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const townhallState = useSelector((s) => s.townhall || {});
  const backdropRef = useRef(null);
  const formRef = useRef(null);

  const formik = useFormik({
    initialValues: { topic: '', name: '' },
    validationSchema: Yup.object().shape({
      topic: Yup.string().required('Required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        await dispatch(submitTownhallTopic(values));
        enqueueSnackbar('Topic submitted. Thank you!', { variant: 'success' });
        resetForm();
        if (typeof onSubmit === 'function') onSubmit(values);
        if (typeof onClose === 'function') onClose();
      } catch (e) {
        enqueueSnackbar(e?.message || 'Failed to submit topic', { variant: 'error' });
      }
    },
  });

  // Ensure modal opens scrolled to the top and content is top-aligned
  useEffect(() => {
    if (backdropRef.current) backdropRef.current.scrollTop = 0;
    if (formRef.current) formRef.current.scrollTop = 0;
  }, []);

  return (
    <div className={styles.backGround} ref={backdropRef}>
      <div
        className={styles.form}
        ref={formRef}
        style={{
          width: '500px',
          maxHeight: '80vh',
          overflowY: 'auto',
          justifyContent: 'flex-start',
          alignItems: 'stretch',
          paddingTop: 12,
          paddingBottom: 8,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.momentTitle}>MOMENT</div>
        <div className={styles.sectionTitle}>Raise topic for Townhall Meeting</div>

        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate style={{ width: '100%' }} onSubmit={formik.handleSubmit}>
            <Grid container sx={{ width: '100%' }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Topic *</p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  value={formik.values.topic}
                  onChange={(e) => formik.setFieldValue('topic', e.target.value)}
                  placeholder="Enter topic"
                  sx={textfieldStyle}
                  error={Boolean(formik.touched.topic && formik.errors.topic)}
                />
              </Grid>
            </Grid>

            <Grid container sx={{ width: '100%', mt: 2 }}>
              <Grid item xs={4} sx={{ pr: 3 }}>
                <p className={styles.dataTitleV2}>Name (leave blank to remain anonymous)</p>
              </Grid>
              <Grid item xs={8} sx={{ mt: 1 }}>
                <TextField
                  fullWidth
                  value={formik.values.name}
                  onChange={(e) => formik.setFieldValue('name', e.target.value)}
                  placeholder="Your name (optional)"
                  sx={textfieldStyle}
                />
              </Grid>
            </Grid>

            <div className={styles.updateAndCancel} style={{ marginTop: 16 }}>
              <div className={styles.updateButton} type="submit" onClick={formik.handleSubmit}>
                <div className={buttonStyles.YesButtonComponentStyling}>SUBMIT</div>
              </div>
              <div className={styles.cancelButton} onClick={onClose}>
                <div className={buttonStyles.NoButtonComponentStyling}>CANCEL</div>
              </div>
            </div>
          </Form>
        </FormikProvider>

        <img className={styles.blueLogo} src={BlueLogo} alt="BlueLogo" style={{ alignSelf: 'center' }} />
      </div>
    </div>
  );
}


